import React from 'react';
import { usePageContent } from '../../hooks/usePageContent';
import styles from './index.module.css';

const ProductCardSkeleton = () => (
  <li className="products__list-item" aria-hidden="true">
    <div className="products__list-link products__list-link--skeleton">
      <div className={`products__list-image ${styles.imagePlaceholder}`} />
      <dl className="products__list-details">
        <dt className="products__list-details-key visuallyhidden">Name:</dt>
        <dd className={`products__list-details-value products__list-details-value--name ${styles.textPlaceholder}`}>&nbsp;</dd>
        <dt className="products__list-details-key visuallyhidden">Price:</dt>
        <dd className={`products__list-details-value products__list-details-value--price ${styles.textPlaceholder}`}>&nbsp;</dd>
      </dl>
      <span className={`products__list-false-cta visuallyhidden ${styles.ctaPlaceholder}`}>&nbsp;</span>
    </div>
  </li>
);

const SKELETON_COUNT = 8;

const DEFAULT_DISCLAIMERS = [
  'Plate images are a guide only. There may be small variations to colour and spacing.',
  'Representations of plates provided on this page are for illustration purposes only, final products may vary slightly from what is displayed on-screen.',
];

export const ProductGridSkeleton = ({ disclaimers, loadingTitle, showCount = false }) => {
  const { find } = usePageContent('product-list');
  const pc = find('productList') || {};

  return (
    <div className="products__section products-section--available">
      <div className="products__header">
        <h3 className="products__title">
          <span className="products__title-option">{loadingTitle || ''}</span>
        </h3>
        {showCount && (
          <p className="products__pagination" role="region" aria-live="polite" aria-atomic="true">
            {pc.showingPrefix || 'Showing'} <span className="products__pagination-amount">0</span> {pc.showingSuffix || 'plate ranges'}
          </p>
        )}
      </div>
      <ul className="products__list" aria-label="Loading styles" aria-busy="true">
        {Array.from({ length: SKELETON_COUNT }, (_, i) => (
          <ProductCardSkeleton key={i} />
        ))}
      </ul>
      <div className="styles__disclaimer">
        {(disclaimers || DEFAULT_DISCLAIMERS).map((text, i) => <p key={i}>{text}</p>)}
      </div>
    </div>
  );
};

export default ProductCardSkeleton;
